export const updateField = (formField, key, value) => {
  if (formField.set) {
    return formField.set(key, value);
  } else {
    formField = Object.assign({}, formField, {
      [key]: value
    });
  }
  return formField;
};